import React, { Component } from "react";
import HotKeysModal from "Components/HotKeysModal";
import platform from "Pub/js/platform";
const { NCCheckbox, NCRadio } = platform.base;
import { langCheck } from "Pub/js/utils";
import "./index.less";
export default class FiletypeModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filetype: "0"
        };
    }
    getfiletypeMap = () => {
        const { json } = this.props;
        return [
            { key: "all", name: `${langCheck("ZoneSetting-000270", "pages", json)}`, value: "" } /* 国际化处理： 全选*/,
            {
                key: "work",
                name: `${langCheck("ZoneSetting-000293", "pages", json)}`,
                value: "ppt、pptx、xls、xlsx、doc、docx、pdf、txt"
            } /* 国际化处理： 办公*/,
            {
                key: "img",
                name: `${langCheck("ZoneSetting-000294", "pages", json)}`,
                value: "png、jpg、heic"
            } /* 国际化处理： 图像*/,
            {
                key: "video",
                name: `${langCheck("ZoneSetting-000295", "pages", json)}`,
                value: "mp4"
            } /* 国际化处理： 视频*/,
            {
                key: "zip",
                name: `${langCheck("ZoneSetting-000296", "pages", json)}`,
                value: "rar 、zip、7z"
            } /* 国际化处理： 压缩文件*/,
            {
                key: "dwg",
                name: `${langCheck("ZoneSetting-000297", "pages", json)}`,
                value: "dwg(AutoCad)"
            } /* 国际化处理： 源文件*/
        ];
    };
    radioChange = val => {
        this.setState({ filetype: val });
    };
    checkboxChange = (val, key) => {
        console.log(val, key);
    };
    renderCheckboxArea = () => {
        return (
            <ul>
                {this.getfiletypeMap().map(item => {
                    return (
                        <li>
                            <NCCheckbox
                                className='dnd-cancel' //必须加。不加的话不能触发click事件
                                onChange={val => {
                                    this.checkboxChange(val, item.key);
                                }}>
                                {item.name}
                            </NCCheckbox>
                            <span>{item.value}</span>
                        </li>
                    );
                })}
            </ul>
        );
    };
    render() {
        const { visible, onOk, onCancel, json } = this.props;
        let { filetype } = this.state;
        return (
            <HotKeysModal
                maskClosable={true}
                customHeader={langCheck("ZoneSetting-000287", "pages", json)} /* 国际化处理： 水印*/
                visible={visible}
                onOk={onOk}
                onCancel={onCancel}
                className='filetypeModal'>
                <NCRadio.NCRadioGroup selectedValue={filetype} onChange={this.radioChange}>
                    <NCRadio value='0'>
                        {langCheck("ZoneSetting-000291", "pages", json) /* 国际化处理： 不限制文件类型*/}
                    </NCRadio>
                    <NCRadio value='1'>
                        {langCheck("ZoneSetting-000292", "pages", json) /* 国际化处理： 限制文件类型*/}
                    </NCRadio>
                </NCRadio.NCRadioGroup>
                {this.renderCheckboxArea()}
            </HotKeysModal>
        );
    }
}
